import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import HttpRetryConfig from './http-resilient/http-retry.config';
import HttpRetryInterceptor from './http-resilient/http-retry.interceptor';
import ErrorInterceptor from './http-resilient/http-error.interceptor';

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRetryInterceptor,
            multi: true,
        },
        { provide: HttpRetryInterceptor.HTTP_RETRY_CONFIG, useValue: HttpRetryConfig },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
    ],
})
export default class AngularUtilsModule {}
